import styled from 'styled-components/macro';

export const FormattedCount = styled.div`
  display: flex;
  height: 24px;
  background: var(--cogs-surface--status-neutral--muted--default);
  color: var(--cogs-text-icon--status-neutral);
  border-radius: 4px;
  padding: 4px 6px;
  margin-left: 2px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
`;
